import { Component, OnInit } from '@angular/core';
import { DynamicFormComponent } from '@components/dynamic-form/dynamic-form.component';
import { Router } from '@angular/router';
import { UserService } from '@services/admin/user.service';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { LoggerService } from '@services/logger.service';
import { OptionSelect } from '@/models/option-select.model';
import { ServicePracticesService } from '@services/data-source-tables/service-practices.service';
import { ServicePracticesModel } from '@/models/tables/service-practices.model';
import { ServicePracticeFormSetting } from '@/form-settings/service-practice-form-setting';

@Component({
  selector: 'app-service-practice-form',
  templateUrl: '../../../../../components/dynamic-form/dynamic-form.component.html',
})
export class ServicePracticeFormComponent extends DynamicFormComponent implements OnInit {
  private typeInsuranceService: OptionSelect[] = [];

  constructor(
    protected router: Router,
    protected userService: UserService,
    protected servicePracticesService: ServicePracticesService,
    protected toastr: ToastrService,
  ) {
    super(toastr, userService);

    this.setupMeta();
    this.submitButtonVisible = true;
    this.primaryButton = 'Salva';
    this.secondaryBottomButton = 'Chiudi';

    Registry.getInstance().set('ServicePracticeFormComponent', this);
  }

  ngOnInit(): void {
    this.form.controls['creator'].setValue(this.userService.getUserName());

    this.servicePracticesService.getAllServicePractices().subscribe({
      next: (typeInsuranceServices) => {
        this.typeInsuranceService = typeInsuranceServices;

        this.setupMeta();
      },
      error: (error) => {
        LoggerService.error('getAllServicePractices failed!');
        LoggerService.error(error);
      },
      complete: () => {
        LoggerService.log('Request done');
      },
    });
  }

  onSubmit() {
    let servicePracticesModel = <ServicePracticesModel>this.form.getRawValue();

    this.servicePracticesService.saveServicePractice(servicePracticesModel).subscribe({
      next: () => {
        this.toastr.success('Servizio pratica salvata correttamente!');

        this.closeModalAndRefresh();
      },
      error: (error) => {
        LoggerService.error('saveServicePractice failed!');
        LoggerService.error(error);

        this.toastr.error(`Errore durante il salvataggio del Servizio pratica.`);

        setTimeout(() => {
          Registry.getInstance().set('saveInProgress', false);
        }, 1000);
      },
      complete: () => {
        LoggerService.log('Request done');

        setTimeout(() => {
          Registry.getInstance().set('saveInProgress', false);
        }, 1000);
      },
    });
  }

  setupMeta(): void {
    this.meta = ServicePracticeFormSetting.set('typeInsuranceService', this.typeInsuranceService)
      .getMeta()
      .sort((a: any, b: any) => a.order - b.order);
  }

  bottomButtonAction() {
    if (this.data.id) {
      Registry.getInstance().get('DialogServicePracticeComponentModify').close();
    } else {
      Registry.getInstance().get('DialogServicePracticeComponentNew').close();
    }
  }

  protected closeModalAndRefresh() {
    if (this.data.id) {
      Registry.getInstance().get('DialogServicePracticeComponentModify').close();
    } else {
      Registry.getInstance().get('DialogServicePracticeComponentNew').close();
    }

    Registry.getInstance().get('ServicePracticesComponent').loadServicePractices();
  }
}
